const AnimatedGradient = `
  color: var(--secondary);
  background-image: linear-gradient(295.03deg, #4C83FF 7.33%, #2AFADF 31.32%, #8C1BAB 62.59%, #F761A1 89.01%);
  background-size: 2000px 1500px;
  animation: gradient 10s infinite linear alternate;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0px 0px #00000000;
  @keyframes gradient {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 100% 100%;
    }
  }
`

export default AnimatedGradient
